import { SectionHeading, Reveal } from "@/components/Reveal";

const STEPS = [
  { num: "01", title: "Explore", text: "Browse available plots." },
  { num: "02", title: "Enquire", text: "Send your requirements to our team." },
  { num: "03", title: "Site Visit", text: "Schedule a visit to the property." },
  { num: "04", title: "Move Forward", text: "Review the property details and proceed according to your requirements." },
];

export default function HowItWorks() {
  return (
    <section data-testid="how-it-works-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="06"
          eyebrow="The Process"
          title="How It Works"
          description="Four simple steps from browsing to moving forward with a plot."
        />
        <div className="relative mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div
            className="absolute left-0 right-0 top-8 hidden border-t-2 border-dashed border-navy/15 lg:block"
            aria-hidden="true"
          />
          {STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.1}>
              <div className="relative">
                <span className="relative z-10 flex h-16 w-16 items-center justify-center rounded-full border-2 border-gold bg-white font-display text-xl font-bold italic text-gold-dark">
                  {step.num}
                </span>
                <h3 className="mt-6 font-display text-2xl font-semibold text-navy">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
